import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';

import { ClientEvents } from '../../constants/clientEvents';

export class ValorMonster1000Handler {
    public handle(): void {
        ClientEventEmitter.fireEvent(ClientEvents.VALOR_MONSTER_1000);
    }
}
